import PropTypes from 'prop-types'
import {
  AppleIcon,
  FacebookIcon,
  GmailIcon,
  Info,
  BanIcon,
} from '../../assets/images/icons'

const IconsList = {
  Apple: <AppleIcon />,
  Facebook: <FacebookIcon />,
  Gmail: <GmailIcon />,
  Info: <Info />,
  Ban: <BanIcon />,
}

const Icon = ({ name }) => IconsList[name] || null

Icon.propTypes = {
  name: PropTypes.string.isRequired,
}

export default Icon
